import React from 'react';
import {View} from 'react-native';
import {Card, Image} from '@rneui/base';
import {makeStyles} from '@rneui/themed';
import Color from 'color';
import {isFunction} from 'lodash';

import brandlogo from '../../../images/brand/header-logo.png';
import Text from '../../themed/Text';
import RewardsProgramImage from '../ProgramImage';

import Barcode from './Barcode';

const useStyles = makeStyles((theme) => {
  return {
    wrapperStyle: {
      alignItems: 'center',
    },
    containerStyle: {
      margin: 0,
      borderRadius: 20,
      backgroundColor: theme?.colors?.legacy?.background?.general?.primary,
      borderWidth: 0,
    },
    barcodeContainerStyle: {
      backgroundColor: theme.colors.white,
      borderRadius: theme.size.s2,
      padding: theme.size.s2,
      alignSelf: 'stretch',
      alignContent: 'center',
      marginTop: 16,
    },
    memberName: {
      color:
        theme.colors?.legacy?.icon?.header?.secondary ||
        theme.colors?.legacy?.icon?.header?.primary,
      fontWeight: 'bold',
      alignSelf: 'flex-start',
      marginTop: 10,
    },
  };
});

type MemberCardProps = {
  logoImg?: any;
  cardNumber: string;
  name: string;
  pending?: boolean;
  children?: ({color}: {color: string}) => React.ReactNode;
};

export default function MemberCard({
  logoImg = brandlogo,
  cardNumber = 'Example 1234',
  name,
  pending,
  children,
}: MemberCardProps) {
  const styles = useStyles();
  return (
    <Card
      wrapperStyle={styles.wrapperStyle}
      containerStyle={styles.containerStyle}
      >
      {!!logoImg && (
        <Image
          containerStyle={{justifyContent: 'center', alignContent: 'center'}}
          source={logoImg}
          style={{
            width: 120,
            height: 32,
          }}
          resizeMode="contain"
        />
      )}

      <RewardsProgramImage
        style={{marginTop: 12, marginBottom: 16}}
        variant={
          Color(styles.containerStyle.backgroundColor).isLight()
            ? 'onLight'
            : 'onDark'
        }
      />

      <View style={[styles.barcodeContainerStyle]}>
        <View style={{alignItems: 'center'}}>
          <Barcode value={cardNumber} height={42} />
        </View>

        <View
          style={{
            marginTop: 10,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <View>
            <Text variant="body2" style={{}}>
              Card number
            </Text>
            {!!pending && (
              <Text variant="body2" style={{fontStyle: 'italic', marginTop: 8}}>
                Pending...
              </Text>
            )}
          </View>
          {!pending && <Text>{cardNumber}</Text>}
        </View>
      </View>
      <Text style={[styles.memberName]}>{name}</Text>
      {!!pending && (
        <View
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            opacity: 0.5,
            left: -16,
            right: -16,
            top: -16,
            bottom: -16,
          }}
        />
      )}
      {isFunction(children)
        ? children({color: styles.memberName.color})
        : children}
    </Card>
  );
}
